import { FilterMoreDisplay } from 'app/modules/filters/components/FilterMoreDisplay';

interface InstrumentFilterDisplayProps {
  externalIds: string[];
  label: string;
}

/**
 * Displays instrument filter values.
 * Instruments filter values are always external IDs, which are already human-readable,
 * so we can display them directly without any lookup or mapping.
 */
export const InstrumentFilterDisplay = ({
  externalIds,
  label,
}: InstrumentFilterDisplayProps) => {
  return (
    <>
      <b>{label}</b> is one of <FilterMoreDisplay values={externalIds} />
    </>
  );
};
